import { AppRoutes } from "../appRoutes.consts"
import {
  isNotEmpty,
  isNotMaxLength,
  isArrayNotEmpty,
} from "../../utils/validations.utils"

export const CLIENT_REPORT_TABS = [
  AppRoutes.reporteCliente.desarrollo,
  AppRoutes.reporteCliente.consumo,
  AppRoutes.reporteCliente.burnchart,
  AppRoutes.reporteCliente.historicoSprints,
  AppRoutes.reporteCliente.tareas,
  AppRoutes.reporteCliente.descargaReporte,
]

export const CLIENT_REPORT_TABS_WITH_ONLY_SPRINTS = [
  AppRoutes.reporteCliente.desarrollo,
  AppRoutes.reporteCliente.historicoSprints,
  AppRoutes.reporteCliente.descargaReporte,
]

export const CLIENT_CONSUMPTION_PERIOD_TYPE_ENUM = {
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
  SPRINT: "SPRINT", // Frontend exclusive
}

export const CLIENT_REPORT_STATUSES = [
  {
    name: "IN_PROGRESS",
    label: "En curso",
    color: "#F5980C",
  },
  {
    name: "CLOSED",
    label: "Cerrado",
    color: "#64748B",
  },
  {
    name: "APPROVED",
    label: "Aprobado",
    color: "var(--clr-success__dark)",
  },
  {
    name: "FINISHED",
    label: "Finalizado",
    color: "var(--clr-success__dark)",
  },
]

export const TOTAL_CLIENT_ESTIMATION = {
  estimationType: "TOTAL_POINTS",
  label: "Puntos planificados",
  description: "Suma de puntos por desarrollar, por estimar y por diseñar",
}

export const CLIENT_ESTIMATION_TYPES = {
  TO_DEVELOP: {
    estimationType: "TO_DEVELOP",
    label: "Por desarrollar",
    description: "Tareas en proceso de desarrollo",
    color: "#F97316",
  },
  TO_ESTIMATE: {
    estimationType: "TO_ESTIMATE",
    label: "Por estimar",
    description: "Tareas en espera de la estimación final de desarrollo",
    color: "#A855F7",
  },
  TO_DESIGN: {
    estimationType: "TO_DESIGN",
    label: "Por diseñar",
    description: "Tareas en proceso de definición de diseño",
    color: "#EC4899",
  },
  TO_DEFINE: {
    estimationType: "TO_DEFINE",
    label: "Por definir",
    description: "Tareas no incluidas en las fases actuales de desarrollo",
    color: "#737E8D",
  },
}

export const CLIENT_REPORT_BUDGET_STATES = {
  OPTIMAL: {
    minRemainingWeeks: 2,
    label: "Óptimo",
    color: "#2CA949",
    iconClassName: "pi-check",
    tooltipValue:
      "El presupuesto cubre el desarrollo con al menos 2 semanas de sobra.",
  },
  IN_RISK: {
    minRemainingWeeks: 1.1,
    label: "En riesgo",
    color: "#F97316",
    iconClassName: "pi-eye",
    tooltipValue: "El presupuesto alcanza justo o hay un pequeño margen.",
  },
  CRITICAL: {
    minRemainingWeeks: 0,
    label: "Crítico",
    color: "#FC3D39",
    iconClassName: "pi-exclamation-triangle",
    tooltipValue:
      "El presupuesto se terminará antes de poder concluir el desarrollo.",
  },
  FINISHED: {
    minRemainingWeeks: -1,
    label: "Agotado",
    color: "#64748B",
    iconClassName: "pi-exclamation-triangle",
    tooltipValue:
      "El presupuesto se terminó antes de poder concluir el desarrollo.",
  },
  WITHOUT_BUDGET: {
    minRemainingWeeks: -1,
    label: "Sin presupuesto",
    tooltipValue: "No se ha creado presupuesto para este cliente.",
  },
}

export const MODAL_FORM_CLOSE_SPRINT_MODE = {
  FINISH: "finish",
  FINISHED_EDIT: "finished_edit",
  APPROVE: "approve",
}

export const MODAL_FORM_CLOSE_SPRINT_INITIAL_STATE = {
  startDate: null,
  endDate: null,
  approvalDate: null,
  teamMembers: [],
  closeType: "NORMAL",
  motivo: "",
  additionalText: "",
  requiresAdditionalText: false,
  milestone: {
    totalPoints: null,
    milestoneName: "",
    nextImportantDate: null,
    nextImportantDateName: "",
  },
}

export const MODAL_FORM_CLOSE_SPRINT_VALIDATIONS = {
  startDate: {
    value: "",
    errors: [],
    typeValidations: [isNotEmpty],
    validationsOptions: {},
  },
  endDate: {
    value: "",
    errors: [],
    typeValidations: [isNotEmpty],
    validationsOptions: {},
  },
  approvalDate: {
    value: null,
    errors: [],
    typeValidations: [],
    validationsOptions: {},
  },
  teamMembers: {
    value: [],
    errors: [],
    typeValidations: [isArrayNotEmpty],
    validationsOptions: {},
  },
  motivo: {
    value: "",
    errors: [],
    typeValidations: [],
    validationsOptions: {},
  },
  additionalText: {
    value: "",
    errors: [],
    typeValidations: [],
    validationsOptions: {},
  },
}

export const CLIENT_SPRINT_STATES = {
  IN_PROGRESS: "IN_PROGRESS",
  CLOSED: "CLOSED",
  APPROVED: "APPROVED",
}

export const MODAL_FORM_EDIT_CLIENT_ESTIMATION_INITIAL_STATE = {
  date: "",
  motive: "",
  TO_DEVELOP: {
    label: "Puntos por desarrollar",
    value: 0,
  },
  TO_ESTIMATE: {
    label: "Puntos por estimar",
    value: 0,
    userStories: 0,
  },
  TO_DESIGN: {
    label: "Puntos por diseñar",
    value: 0,
    userStories: 0,
  },
  TO_DEFINE: {
    label: "Puntos por definir",
    value: 0,
    userStories: 0,
  },
}

export const MODAL_FORM_EDIT_CLIENT_ESTIMATION_VALIDATIONS = {
  date: {
    value: "",
    errors: [],
    typeValidations: [isNotEmpty],
    validationsOptions: {},
  },
  motive: {
    value: "",
    errors: [],
    typeValidations: [isNotEmpty, isNotMaxLength],
    validationOptions: { isNotMaxLength: { max: 255 } },
  },
  TO_DEVELOP: {
    value: {
      label: "Puntos por desarrollar",
      value: 0,
      userStories: 0,
    },
    errors: [],
    typeValidations: [isNotEmpty],
    validationsOptions: {},
  },
  TO_ESTIMATE: {
    value: {
      label: "Puntos por estimar",
      value: 0,
      userStories: 0,
    },
    errors: [],
    typeValidations: [isNotEmpty],
    validationsOptions: {},
  },
  TO_DESIGN: {
    value: {
      label: "Puntos por diseñar",
      value: 0,
      userStories: 0,
    },
    errors: [],
    typeValidations: [isNotEmpty],
    validationsOptions: {},
  },
  TO_DEFINE: {
    value: {
      label: "Puntos por definir",
      value: 0,
      userStories: 0,
    },
    errors: [],
    typeValidations: [isNotEmpty],
    validationsOptions: {},
  },
}

export const ESTIMATION_MAX_INPUT_NUMBER_VALUE = 9999
export const ESTIMATION_MAX_MOTIVE_LENGTH = 255

export const GENERAL_SPRINT_PROGRESS_CHART_INITIAL_STATE = [
  {
    data: [
      {
        value: 0,
        name: "",
      },
    ],
  },
]

export const CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES = {
  BY_AREA: "byArea",
  BY_PROJECT: "byProject",
}

export const BURNCHART_ESTIMATION_TYPES = {
  NOMINAL: "nominal",
  OPTIMISTIC: "optimistic",
  PESSIMISTIC: "pessimistic",
}

export const BURNCHART_ESTIMATION_DEFAULT_SPREAD = 0.2

export const INITIAL_BURNCHART_STATE = {
  averagePointsPerSprint: null,
  totalPointsToComplete: null,
  totalCompletedPoints: null,
}

export const INITIAL_BURNCHART_ESTIMATED_SPRINTS = {
  estimatedSprint: 0,
  optimisticSprint: 0,
  pessimisticSprint: 0,
}

export const MAX_BURNCHART_PREDICTION_AVERAGE_POINTS_PER_SPRINT = 99
export const MAX_BURNCHART_PREDICTION_TO_DEVELOP_POINTS = 9999

export const CLIENT_SPRINT_CARD_MODES = {
  EDITABLE: "editable",
  VIEW_ONLY: "view_only",
}

export const CLIENT_SPRINT_CARD_SIZE_MODES = {
  COMPACT: "compact",
  LONG: "long",
}

export const FIRST_SPRINT_NUMBER = 1

export const CLOSE_TYPES = {
  NORMAL: "NORMAL",
  TIMEOUT: "TIMEOUT",
}

export const CLOSE_TYPE_LABELS = {
  TIMEOUT: "Time out",
}

export const SPRINT_DURATION_DAYS = 7

export const CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY = {
  BLOCK: "BLOCK",
  CYCLE: "CYCLE",
}

export const NON_TOGGLEABLE_SECTIONS = {
  SUMMARY: "SUMMARY",
  NOTES: "NOTES",
}

export const CLIENT_HORIZON_ESTIMATION_TYPES = {
  READY: {
    key: "READY",
    label: "Listos para desarrollo",
    shortLabel: "Listos",
    estimationTypes: ["TO_DEVELOP"],
    color: "#00B4FF",
    valueLabel: "pts dev",
    extraLabel: " ",
  },

  DEFINITION: {
    key: "DEFINITION",
    label: "En proceso de definición",
    shortLabel: "Definición",
    estimationTypes: ["TO_ESTIMATE", "TO_DESIGN"],
    color: "linear-gradient(135deg, #FFC515 0%, #F5980C 100%)",
    valueLabel: "pts dev",
    extraLabel: "~ ",
  },

  UNDEFINED: {
    key: "UNDEFINED",
    label: "Sin definición",
    shortLabel: "Sin definición",
    estimationTypes: ["TO_DEFINE"],
    color: "#D9342B",
    valueLabel: "pts backlog",
    extraLabel: " ",
  },
}

export const COLOR_MAP = {
  TO_DEVELOP: "#00B4FF",
  TO_ESTIMATE: "#FFC515",
  TO_DESIGN: "#F5980C",
  TO_DEFINE: "#D9342B",
}

export const CLIENT_REPORT_ALWAYS_VISIBLE_SECTIONS = [
  "TITLE",
  "FOOTER",
  "NOTES",
]

export const PERIOD_LABELS = {
  sprint: "sprint",
  block: "bloque",
  cycle: "ciclo",
}

export const weekToBlockDivider = 2.3
